/**
 * OnlineDetector
 * 
 */
import React, { useEffect, useState } from 'react';
import ErrorMessage from '../error-message/ErrorMessage';
// $FlowFixMe
import styles from './OnlineDetector.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const OnlineDetector = () => {
  const [online, setOnline] = useState(window.navigator.onLine);
  useEffect(() => {
    const isOnline = e => {
      const result = e.type === 'offline' ? false : true;
      setOnline(result);
    };
    window.addEventListener('offline', isOnline);
    window.addEventListener('online', isOnline);
    return () => {
      window.removeEventListener('offline', isOnline);
      window.removeEventListener('online', isOnline);
    };
  }, [online]);
  if (online) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.OnlineDetector,
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      error: true,
      message: "It appears that you are offline, please check your network connection before uploading an image"
    })
  });
};
export default OnlineDetector;